import {Injectable} from '@angular/core';
import {LaunchDialogService} from '@spartacus/storefront';
import {BehaviorSubject} from 'rxjs';
import {tap} from 'rxjs/operators';

import {
    AimoProductSummaryDialogData,
    PRODUCT_SUMMARY
} from '../../cms-components/product/product-summary/product-summary-layout.config';
import {AimoProduct} from '../../model/product.model';
import {AimoGTMProductAttributes, GTMEventCode} from '../gtm/aimo-gtm.model';

import {AimoCurrentProductService} from './aimo-current-product.service';
import {AimoProductService} from './aimo-product.service';

@Injectable({
    providedIn: 'root',
})
export class AimoProductModalService {

    constructor(
        protected launchDialogService: LaunchDialogService,
        protected currentProductService: AimoCurrentProductService,
        protected lProductService: AimoProductService,
    ) {
    }

    public openProductModal(
        productCode: string,
        gtmProductAttributes: AimoGTMProductAttributes,
        scrollToId?: string,
        addToCartCallBack?: BehaviorSubject<number>,
        openModalAfterClose?: string,
        focusIdAfterClose?: string,
        onProductChangeCallBack?: BehaviorSubject<AimoProduct>,
    ): void {
        this.launchDialogService.closeDialog(null);
        this.currentProductService.setProduct(productCode);
        this.launchDialogService.openDialogAndSubscribe(PRODUCT_SUMMARY, undefined, {
            addToCartCallBack,
            openModalAfterClose,
            onProductChangeCallBack,
            product: this.currentProductService.getProduct2(gtmProductAttributes).pipe(
                tap((product) =>
                    this.lProductService.fireSingleProductGtmEvent(
                        {...product, gtmProductAttributes},
                        GTMEventCode.SelectItem,
                        'similar-products-container' === scrollToId,
                    ),
                ),
            ),
            scrollToId,
            focusIdAfterClose,
            gtmProductAttributes
        } as AimoProductSummaryDialogData);
    }
}

